/* istanbul ignore file */
// we don't test SVGs without arguments
import React from 'react'
import PropTypes from 'prop-types'

const IconTarget = ({ color = '#3C6E90', width = 19, height = 18 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="9.5"
      cy="9"
      r="8"
      fill="#EEF0F2"
      stroke={color}
      strokeWidth="2"
    />
    <circle
      cx="9.5"
      cy="9"
      r="3"
      fill="#EEF0F2"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
)

IconTarget.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
}

export default IconTarget
